import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';

import GameScreen from 'screens/GameScreen';
import LanguageWrapper from 'components/LanguageWrapper';

const homeScreen = (
  <LanguageWrapper>
    <GameScreen />
  </LanguageWrapper>
);

const router = createBrowserRouter([
  {
    path: '/',
    element: homeScreen,
  },
  {
    path: '/:language',
    element: homeScreen,
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
